import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { create } from "../../services/services";
import Layout from "./layout";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchReservationById } from "../../store/slices/rendezVousSlice";
import { fetchEtablissementById } from "../../store/slices/etablissementSlice";
import Skeleton from "react-loading-skeleton";
import { Helmet, HelmetProvider } from "react-helmet-async";

const CheckoutForm = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [clientSecret, setClientSecret] = useState(null);
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  // console.log(adresse_facturation);
  const etablissement = useSelector(
    (state) => state.etablissements.selectedEtablissement
  );
  const { currentReservation, currentReservationStatus } = useSelector(
    (state) => state.rendezvous
  );

  const fetchSecret = async (id) => {
    const data = { reservation_id: id };
    create(data, "reservation/initiate-payment")
      .then((res) => {
        setClientSecret(res?.data?.clientSecret);
        setLoading(false);
      })
      .catch((err) => {
        // console.error(err);
        setError("Une erreur est survenue lors de l'enregistrement");
        setLoading(false);
      });
  };

  useEffect(() => {
    // Fetch reservation when component mounts or id changes
    dispatch(fetchReservationById(id));
  }, [dispatch, id]);

  useEffect(() => {
    // This will run whenever currentReservationStatus or currentReservation changes
    if (
      currentReservationStatus === "succeeded" &&
      currentReservation?.etablissement_id
    ) {
      dispatch(fetchEtablissementById(currentReservation.etablissement_id));
      fetchSecret(currentReservation.id);
    }
  }, [currentReservationStatus, currentReservation, dispatch]);

  const options = {
    clientSecret,
  };

  if (error) return <div>Error: {error}</div>;
  if (loading || !clientSecret)
    return (
      <Layout currentStep={3} etablissement={etablissement} from="reservation">
        <div className="row">
          <div className="col-md-8">
            <div className="adr-fact card-grey d-flex flex-between">
              <Skeleton height={100} width="100%" />
            </div>
            <div
              style={{ minHeight: "400px", width: "100%", marginTop: "24px" }}
            >
              <Skeleton height={400} width="100%" />
            </div>
          </div>
          <div className="col-md-4">
            <div
              style={{ minHeight: "400px", width: "100%", marginTop: "24px" }}
            >
              <Skeleton height={400} width="100%" />
            </div>
          </div>
        </div>
      </Layout>
    );
  return (
    <Layout
      currentStep={3}
      etablissement={etablissement}
      prestation={currentReservation?.prestations_snapshot}
      recap={true}
      from="facturation"
      btnPay={true}
      conf={true}
      btn={false}
      reservation_id={id}
    >
      <HelmetProvider>
        <Helmet>
          <title>Page Paiement réservation </title>
          <meta name="description" content="Paiemenyt réservation" />
        </Helmet>
      </HelmetProvider>
      <div className="adr-fact card-grey d-flex flex-between">
        <div>
          {" "}
          <p className="body grey500">
            {currentReservation?.adresse_facturation?.numero_rue}{" "}
          </p>
          <p className="body grey500">
            {currentReservation?.adresse_facturation?.complement_adresse}{" "}
          </p>
          <p className="body grey500">
            {" "}
            {currentReservation?.adresse_facturation?.code_postal}{" "}
            {currentReservation?.adresse_facturation?.ville}
          </p>
        </div>
        <div>
          <a className="link-blue" href={`/facturation/${id}`}>
            {" "}
            Modifier{" "}
            <img src="/images/edit.svg" alt="icon edit" className="ml-8" />
          </a>{" "}
        </div>
      </div>
      <div style={{ minHeight: "400px", width: "100%", marginTop: "24px" }}>
        {clientSecret && (
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout
              style={{
                width: "100%",
                minWidth: "100%",
                display: "block",
              }}
              className="StripeEmbeddedCheckout"
            />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </Layout>
  );
};

export default CheckoutForm;
